import React__default, { useState } from 'react';
import { Slider as Slider$1, Label, SliderOutput, SliderTrack, SliderThumb } from 'react-aria-components';
import { ContentWithTooltip } from '../molecules/Tooltip/ContentWithTooltip.js';
import './Slider.scss';

const Slider = (props) => {
    const isVertical = props.orientation === 'vertical';
    const [openTooltipIndex, setOpenTooltipIndex] = useState(undefined);
    // No tooltip on touch devices. We’d love to show these on touch devices
    // but there are some bugs with it that we haven't had time to solve yet.
    const isTouchDevice = matchMedia('(pointer:coarse)').matches;
    return (React__default.createElement(Slider$1, { ...props, "data-rev-component": 'slider', className: props.className, "aria-label": props.label || props['aria-label'] || 'Slider' },
        React__default.createElement("div", { className: 'slider-header--rev' },
            props.label && React__default.createElement(Label, null, props.label),
            props.showSideValue && (React__default.createElement(SliderOutput, { className: 'slider-output--rev' }, ({ state }) => state.values
                .map((_, i) => props.formatValue
                ? props.formatValue(Number(state.getThumbValueLabel(i).replace(/,/g, '')))
                : state.getThumbValueLabel(i))
                .join(' – ')))),
        React__default.createElement(SliderTrack, { className: 'slider-track--rev' }, ({ state }) => {
            // For single thumb: fill from start -> thumb
            // For range: fill between the two thumbs
            const isRange = state.values.length === 2;
            const start = isRange ? state.getThumbPercent(0) * 100 : 0;
            const end = isRange
                ? state.getThumbPercent(1) * 100
                : state.getThumbPercent(0) * 100;
            return (React__default.createElement(React__default.Fragment, null,
                React__default.createElement("div", { className: 'slider-fill--rev', style: isVertical
                        ? {
                            position: 'absolute',
                            bottom: `${start}%`,
                            height: `${end - start}%`,
                            left: 0,
                            right: 0,
                        }
                        : {
                            position: 'absolute',
                            left: `${start}%`,
                            width: `${end - start}%`,
                            top: 0,
                            bottom: 0,
                        } }),
                state.values.map((_, i) => (React__default.createElement(React__default.Fragment, { key: i }, props.showTooltipValue ? (React__default.createElement(ContentWithTooltip, { isOpen: i === openTooltipIndex, content: React__default.createElement(SliderThumb, { className: 'slider-thumb--rev', key: i, index: i, "aria-label": props.thumbLabels?.[i], onHoverChange: (isHovering) => setOpenTooltipIndex(isHovering && !isTouchDevice
                            ? i
                            : undefined), onFocusChange: (isFocused) => setOpenTooltipIndex(isFocused && !isTouchDevice
                            ? i
                            : undefined) }), tooltipContent: props.formatValue
                        ? props.formatValue(Number(state
                            .getThumbValueLabel(i)
                            .replace(/,/g, '')))
                        : state.getThumbValueLabel(i), tooltipProps: {
                        placement: isVertical ? 'right' : 'top',
                        ...props.tooltipProps,
                        className: 'slider-thumb-tooltip--rev',
                    } })) : (React__default.createElement(SliderThumb, { className: 'slider-thumb--rev', index: i, "aria-label": props.thumbLabels?.[i] })))))));
        })));
};

export { Slider };
//# sourceMappingURL=Slider.js.map
